module.exports = __webpack_public_path__ + "static/media/apseal@2x.40aa002c.png";